/**
 * Mirror of the API's TenantCode: the tenant's machine identity as the `tenant.{code}` directory
 * role carries it, and the stem its bus and storage names fall back to. Kept in lockstep with
 * src/Application/Common/TenantCode.cs — the dialog validates with the same shape the API refuses
 * on, so a code that passes here is a code the API takes.
 */

export const tenantCodeMaxLength = 40;

/** Lowercase letters/digits in dash-separated runs: `sa-svk-d2`, never `-lead`, `trail-` or `a--b`. */
const codeShape = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/** What the API stores: trimmed and lowercased, so `  SA-SVK-D2  ` and `sa-svk-d2` are one code. */
export function normalizeTenantCode(value: string): string {
  return value.trim().toLowerCase();
}

export function isValidTenantCode(code: string): boolean {
  return code.length > 0 && code.length <= tenantCodeMaxLength && codeShape.test(code);
}

/** The inbox container a tenant falls back to when it sets no override. */
export function derivedContainerName(code: string): string {
  return `algobridge-${code}`;
}

export function derivedQueueInName(code: string): string {
  return `algobridge-${code}-in`;
}

export function derivedQueueOutName(code: string): string {
  return `algobridge-${code}-out`;
}
